import { __rest } from '/Users/gimboseog/development/moim-frontend/node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { Link } from '../../components/link.mjs';
import * as React from 'react';
import { withPlacement } from '../../hoc/withPlacement.mjs';
import { Wrapper, TextButton, GhostButton, FlatButton } from './styled.mjs';

var ButtonElement = function ButtonElement(_ref) {
  var subType = _ref.subType,
    content = _ref.content,
    size = _ref.size,
    color = _ref.color,
    scale = _ref.scale,
    style = _ref.style;
  var shortSize = React.useMemo(function () {
    switch (size) {
      case "large":
        return "l";
      case "medium":
        return "m";
      case "custom":
        return "custom";
      case "small":
        return "s";
    }
  }, [size]);
  switch (subType) {
    case "flat":
      return jsx(FlatButton, {
        size: shortSize,
        color: color,
        scale: scale,
        customStyle: style,
        children: content
      });
    case "ghost":
      return jsx(GhostButton, {
        size: shortSize,
        color: color,
        scale: scale,
        customStyle: style,
        children: content
      });
    case "text":
    default:
      return jsx(TextButton, {
        size: shortSize,
        color: color,
        scale: scale,
        customStyle: style,
        children: content
      });
  }
};
var Buttons = function Buttons(_a) {
  var _b;
  var _onClick = _a.onClick,
    block = __rest(_a, ["onClick"]);
  return jsx(Wrapper, {
    align: (_b = block.align) !== null && _b !== void 0 ? _b : "center",
    children: jsx(Link, {
      href: block.href,
      onClick: function onClick(e) {
        return _onClick === null || _onClick === void 0 ? void 0 : _onClick(e, block);
      },
      children: jsx(ButtonElement, Object.assign({}, block))
    })
  });
};
var index = withPlacement(Buttons);

export { index as default };
